import { render, staticRenderFns } from "./GenericArtistCard.vue?vue&type=template&id=24dcb941&scoped=true"
import script from "./GenericArtistCard.vue?vue&type=script&lang=js"
export * from "./GenericArtistCard.vue?vue&type=script&lang=js"
import style0 from "./GenericArtistCard.vue?vue&type=style&index=0&id=24dcb941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dcb941",
  null
  
)

export default component.exports